const timingScenarios = [
  {
    timeline: "48 Hours or Less",
    icon: "ri-alarm-warning-line",
    color: "bg-red-50 border-red-200",
    iconColor: "bg-red-100 text-red-600",
    label: "Emergency",
    labelColor: "bg-red-100 text-red-700",
    cases: [
      "Eastman executive with urgent overseas client summit this week",
      "BAE Systems contractor with unexpected overseas deployment",
      "Sullivan County family with international emergency",
      "Corporate traveler with last-minute business crisis abroad",
    ],
    action: "Call us immediately. Corporate emergency processing available within 24 hours.",
    cta: "Get Emergency Help",
    ctaStyle: "bg-red-600 text-white hover:bg-red-700",
  },
  {
    timeline: "3–14 Days Away",
    icon: "ri-time-line",
    color: "bg-[#F6C344]/10 border-[#F6C344]",
    iconColor: "bg-[#F6C344]/20 text-[#1A365D]",
    label: "Rush Processing",
    labelColor: "bg-[#F6C344] text-[#1A365D]",
    cases: [
      "Eastman international plant visit to Germany or Netherlands",
      "BAE Systems UK partner facility trip",
      "Holston plant technical exchange with overseas officials",
      "Ballad Health physician at international medical congress",
    ],
    action: "Our 3–5 day rush service is designed for corporate travel timelines.",
    cta: "Start Rush Application",
    ctaStyle: "bg-[#F6C344] text-[#1A365D] hover:bg-[#e5b33f]",
  },
  {
    timeline: "3–8 Weeks Away",
    icon: "ri-calendar-line",
    color: "bg-[#EEF2F8] border-[#1A365D]/20",
    iconColor: "bg-[#EEF2F8] text-[#1A365D]",
    label: "Standard Expedited",
    labelColor: "bg-[#1A365D]/10 text-[#1A365D]",
    cases: [
      "Sullivan County family vacation to Europe or the Caribbean",
      "Kingsport residents on a cruise from Miami or Tampa",
      "Bristol border community family trip abroad",
      "Annual Eastman business trip with advance scheduling",
    ],
    action: "Standard expedited service delivers in 2–3 weeks — plenty of time.",
    cta: "Start Application",
    ctaStyle: "bg-[#1A365D] text-white hover:bg-[#1A365D]/90",
  },
];

export default function KingsportTravelTimingSection() {
  return (
    <section id="travel-timing" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Travel Timing Guide</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            When Do You Need to Travel?
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From Eastman emergency corporate travel to Sullivan County family holidays — here's the right service level for your departure date.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {timingScenarios.map((scenario, i) => (
            <div key={i} className={`bg-white rounded-xl border-2 ${scenario.color} p-8 flex flex-col`}>
              <div className="flex items-center gap-3 mb-6">
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${scenario.iconColor}`}>
                  <i className={`${scenario.icon} text-xl`}></i>
                </div>
                <div>
                  <span className={`inline-block text-xs font-bold px-3 py-1 rounded-full ${scenario.labelColor}`}>
                    {scenario.label}
                  </span>
                  <p className="font-serif font-bold text-[#1A365D] text-lg mt-1">{scenario.timeline}</p>
                </div>
              </div>
              <ul className="space-y-3 mb-6 flex-1">
                {scenario.cases.map((c, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-arrow-right-s-line text-[#F6C344] mt-0.5 flex-shrink-0"></i>
                    <span>{c}</span>
                  </li>
                ))}
              </ul>
              <p className="text-sm text-gray-500 italic mb-5">{scenario.action}</p>
              <a
                href="https://fastpassportcenter.com/checkout/"
                className={`block w-full text-center font-semibold py-3 rounded-lg transition-all whitespace-nowrap ${scenario.ctaStyle}`}
              >
                {scenario.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}